import { render, staticRenderFns } from "./PentominoSolver.vue?vue&type=template&id=129b5b80&lang=pug"
import script from "./PentominoSolver.vue?vue&type=script&lang=js"
export * from "./PentominoSolver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports